/** One deterministic incident shared by both public walkthroughs. */
export const INCIDENT_SCENARIO = Object.freeze({
  business: {
    id: "demo-traveler-car-rental",
    name: "Traveler Car Rental",
    city: "Dumaguete City",
    email: "support@traveler-demo.example",
    phone: "+63 917 555 0142",
  },
  currentRenter: { name: "Rafael Uy" },
  affectedRenter: { name: "Anna Reyes", email: "anna@example.com", phone: "0917 555 0188" },
  booking: { id: "vb-1", reference: "TCR-4821" },
  damagedVehicle: {
    id: "incident-kia-rio", name: "Kia Rio", plate_number: "PYR-5502",
    category: "Sedan", transmission: "Automatic", seats: 5, price_per_day: 2400,
  },
  replacementVehicle: {
    id: "incident-montero", name: "Toyota Montero", plate_number: "KDQ-7710",
    category: "SUV", transmission: "Automatic", seats: 7, price_per_day: 3200,
  },
  safeNotice: "There may be an issue with your upcoming booking. Please contact your rental provider for more information.",
  accidentNote: "Front-left impact reported by the current renter. Vehicle removed from service pending inspection and repair.",
  remainingDamageNote: "Cosmetic front-left panel damage remains after the completed repair. Kept on the vehicle history.",
});

export const INCIDENT_DEMO_COMPANY = Object.freeze({
  id: INCIDENT_SCENARIO.business.id,
  public_slug: "traveler-car-rental-demo",
  name: INCIDENT_SCENARIO.business.name,
  city: INCIDENT_SCENARIO.business.city,
  is_demo: true,
  online_booking_enabled: false,
  public_description_full: "A fictional local fixture used only inside the ConfirmPH incident walkthrough.",
  public_pickup_locations: ["Traveler Car Rental office"],
  contact: { email: INCIDENT_SCENARIO.business.email, phone: INCIDENT_SCENARIO.business.phone },
  vehicles: [INCIDENT_SCENARIO.damagedVehicle, INCIDENT_SCENARIO.replacementVehicle],
  reviews: [], rating_count: 0, rating_avg: 0,
});

export const INCIDENT_CHAT = Object.freeze({
  affectedRenter: [
    { from: "customer", text: "Hi, I got a notification that there might be a problem with my booking. What's wrong?" },
    { from: "business", text: "Hi Anna. The assigned vehicle was involved in an accident and is unavailable. We're checking another suitable vehicle now." },
  ],
  accident: [
    { from: "customer", text: "Hi, I was in an accident with the car. Everyone is safe, but the front-left side is damaged." },
    { from: "customer", text: "I've sent a photo so you can record what happened." },
  ],
  recovery: [
    { from: "business", text: "The repair is complete and the vehicle has been cleared for use. Some cosmetic damage remains and should stay on its record." },
  ],
});
